import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon4: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 22.0

  const originalHeight = 10.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 22 10" width={width} height={height} {...props}>
      <Path
        d="M4.005 2.87399C4.005 2.59799 4.229 2.37399 4.505 2.37399C4.781 2.37399 5.005 2.59799 5.005 2.87399V8.448C5.005 8.934 4.383 9.13399 4.099 8.73999L1 4.42599V8.448C1 8.724 0.776 8.948 0.5 8.948C0.223 8.948 0 8.724 0 8.448V2.87399C0 2.38799 0.622006 2.188 0.906006 2.582L4.005 6.89499V2.87399ZM12.62 1.47C14.075 2.244 15.003 3.754 15.003 5.427C15.003 7.904 12.987 9.91101 10.502 9.91101C8.017 9.91101 6.00101 7.904 6.00101 5.427C6.00101 3.753 6.93001 2.24299 8.38501 1.46899C8.62901 1.33999 8.932 1.43199 9.061 1.67599C9.191 1.91999 9.09901 2.22299 8.85501 2.35199C7.72301 2.95399 7.00101 4.127 7.00101 5.427C7.00101 7.351 8.568 8.91101 10.502 8.91101C12.436 8.91101 14.003 7.351 14.003 5.427C14.003 4.128 13.282 2.955 12.15 2.353C11.907 2.223 11.814 1.91999 11.944 1.67599C12.074 1.43299 12.377 1.34 12.62 1.47ZM10.502 0C10.778 0 11.002 0.224 11.002 0.5V3.5C11.002 3.776 10.778 4 10.502 4C10.226 4 10.002 3.776 10.002 3.5V0.5C10.002 0.224 10.226 0 10.502 0ZM17.802 8.61899C17.625 9.10699 16.913 9.035 16.837 8.521L16.016 2.94699C15.975 2.67399 16.164 2.42 16.437 2.379C16.71 2.339 16.965 2.52799 17.005 2.80099L17.538 6.41602L18.532 3.677C18.692 3.238 19.313 3.238 19.472 3.677L20.466 6.42401L21.012 2.79901C21.053 2.52601 21.308 2.338 21.581 2.379C21.854 2.421 22.042 2.675 22.001 2.948L21.161 8.522C21.084 9.035 20.373 9.10601 20.197 8.61801L19.001 5.315L17.802 8.61899Z"
        fill="#F3123C"
      />
    </Icon>
  )
}
